// src/views/StakeView/ActionBar.jsx
import React from 'react';

export const ActionBar = ({ 
  selectedNFTs = [], 
  selectedStakedNFTs = [],
  selectedUnstakedNFTs = [],
  isApproved, 
  loading, 
  handleStake, 
  handleUnstake,
  approveStaking,
  emissionRate = '0',
  onDeselectAll
}) => {
  if (selectedNFTs.length === 0) return null;

  const totalSelected = selectedNFTs.length;
  const stakeableCount = selectedUnstakedNFTs.length;
  const unstakeableCount = selectedStakedNFTs.length;

  return (
    <div className="sticky top-0 z-40 mb-6">
      <div className={`p-4 border-4 border-black shadow-[0_4px_0_0_#000] ${
        stakeableCount > 0 && !isApproved
          ? 'bg-gradient-to-r from-yellow-400 to-yellow-600'
          : stakeableCount > 0
          ? 'bg-gradient-to-r from-green-400 to-green-600'
          : 'bg-gradient-to-r from-yellow-400 to-yellow-600'
      } text-black`}>
        
        <div className="flex items-center justify-between gap-4">
          {/* Left: Selection Info */}
          <div className="font-black text-lg flex items-center gap-3">
            <span className="bg-black text-white px-3 py-1 border-2 border-white">
              {totalSelected} SELECTED
            </span>
            
            {stakeableCount > 0 && (
              <span className="hidden sm:inline text-sm">
                → {stakeableCount} ready to stake
              </span>
            )}
            
            {unstakeableCount > 0 && (
              <span className="hidden sm:inline text-sm">
                → {unstakeableCount} ready to unstake
              </span>
            )}
          </div>
          
          {/* Right: Action Buttons */}
          <div className="flex items-center gap-2">
            {/* STAKE Button */}
            {stakeableCount > 0 && (
              !isApproved ? (
                <button 
                  onClick={approveStaking}
                  disabled={loading}
                  className="font-bold py-2 px-6 border-2 border-black bg-white text-black hover:opacity-90 transition-all disabled:opacity-50"
                >
                  {loading ? 'APPROVING...' : '🔒 APPROVE FIRST'}
                </button>
              ) : (
                <button 
                  onClick={handleStake}
                  disabled={loading}
                  className="font-bold py-2 px-6 border-2 border-black bg-white text-black hover:opacity-90 transition-all disabled:opacity-50"
                >
                  {loading ? 'STAKING...' : `🚀 STAKE ${stakeableCount}`}
                </button>
              )
            )}
            
            {/* UNSTAKE Button */}
            {unstakeableCount > 0 && (
              <button 
                onClick={handleUnstake}
                disabled={loading}
                className="font-bold py-2 px-6 border-2 border-black bg-white text-black hover:opacity-90 transition-all disabled:opacity-50"
              >
                {loading ? 'UNSTAKING...' : `📦 UNSTAKE ${unstakeableCount}`}
              </button>
            )}
            
            {/* Clear Button */}
            <button 
              onClick={onDeselectAll}
              className="px-3 py-2 bg-black/40 border-2 border-black/50 hover:bg-black/60 transition-all font-bold text-xs text-white"
            >
              CLEAR
            </button>
          </div>
        </div>

        {/* Earnings estimate */}
        {stakeableCount > 0 && isApproved && (
          <div className="mt-2 text-center text-sm font-bold">
            Est. earnings: ~{(stakeableCount * parseFloat(emissionRate || '0') * 86400).toFixed(1)} POGE/day
          </div>
        )}
      </div>
    </div>
  );
};